import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/pro-regular-svg-icons";
import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import { useAuth } from "../../providers/AuthContext";
import { getUserProgramByPublicId, updateUserProgram } from "../../api/Agreement";
import toast from "react-hot-toast";
import ConfirmationModal from "../../components/ConfirmationModal";
import LoadingTablePage from "../LoadingTablePage";
import ProgramForm from "../../components/userProgram/ProgramForm";
import Breadcrumbs from "../../components/Breadcrumbs";

const EditUserProgramPage = () => {
  const { userProgramPublicId } = useParams();
  const { getAccessToken } = useAuth();
  const navigate = useNavigate();
  const [program, setProgram] = useState(null);
  const [loadingUserProgram, setLoadingUserProgram] = useState(true);
  const [hasChanges, setHasChanges] = useState(false);
  const [confirmState, setConfirmState] = useState({ isOpen: false, id: "" });

  useEffect(() => {
    if (userProgramPublicId) {
      handleGetUserProgram();
    }
  }, [userProgramPublicId]);

  const handleGetUserProgram = async () => {
    try {
      const accessToken = await getAccessToken();
      const program = await getUserProgramByPublicId(userProgramPublicId, accessToken);

      setProgram(program);
    } catch (error) {
      console.error("Failed to fetch user program:", error);
    }
    setLoadingUserProgram(false);
  };

  const handleBackClick = () => {
    if (hasChanges) {
      setConfirmState({
        isOpen: true,
        title: "Discard changes?",
        confirm: () => navigate(-1),
      });
    } else {
      navigate(-1);
    }
  };

  const handleUpdateUserProgram = async () => {
    try {
      const accessToken = await getAccessToken();

      if (!accessToken) {
        toast.error("Authorization failed. Please log in again.");
        return;
      }

      const userProgramData = {
        userProgramPublicId: program.userProgramPublicId,
        description: program.description,
        displayName: program.displayName,
      };

      console.log("Sending updated user program:", userProgramData); // Debug: Check what is being sent

      await updateUserProgram(userProgramData, accessToken);

      toast.success("User program updated successfully", {
        iconTheme: { primary: "#4CAF50", secondary: "#DFF2BF" },
      });
      window.dispatchEvent(new Event("userProgramUpdated"));

      setHasChanges(false);
    } catch (error) {
      toast.error("Failed to update user program");
    }
    navigate(-1);
  };

  console.log("PROGRAM:", program);

  return (
    <>
      <HeaderBar />
      <div className="flex flex-row w-full">
        <Sidebar />
        <main className="page">
          <div className="absolute w-full pointer-events-none">
            <LoadingTablePage title={"Edit user program"} loading={loadingUserProgram} />
          </div>
          <div className={`${loadingUserProgram ? "loading" : ""} page-content`}>
            <Breadcrumbs />
            <div className="flex flex-row items-center pb-4">
              <button onClick={handleBackClick} className="text-black flex">
                <FontAwesomeIcon icon={faArrowLeftLong} className="w-4 pr-4" />
              </button>
              <h2 className="border-l border-mute-200 pl-4">Edit user program: {program?.displayName || "Unknown"}</h2>
              <div className="flex gap-4 ml-auto">
                <button
                  className="btn btn-outline-primary"
                  onClick={handleBackClick}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  disabled={!hasChanges}
                  onClick={handleUpdateUserProgram}
                >
                  Save
                </button>
              </div>
            </div>
            <div className="flex flex-col px-4 py-8 shadow-lg border rounded-md w-full gap-4">
              <ProgramForm
                program={program}
                setProgram={setProgram}
                setHasChanges={setHasChanges}
                disabled={false}
              />
            </div>
          </div>
        </main>
      </div>
      <ConfirmationModal
        isOpen={confirmState.isOpen}
        title={confirmState.title || "Discard changes?"}
        onClose={() => setConfirmState({ isOpen: false })}
        onConfirm={() => {
          setConfirmState({ isOpen: false });
          confirmState.confirm();
        }}
      />
    </>
  );
};

export default EditUserProgramPage;
